import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import s from './TimeChunk.scss';
import cls from 'classnames/bind';
import _noop from 'lodash/noop';

const cx = cls.bind(s);
class TimeChunk extends PureComponent {
  static propTypes = {
    isSelected: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    time: PropTypes.string.isRequired,
    onTimeSelect: PropTypes.func.isRequired,
    onTimeHover: PropTypes.func,
  };

  static defaultProps = {
    onTimeHover: _noop,
  };

  handleClick = () => {
    const { time, onTimeSelect } = this.props;

    onTimeSelect(time);
  };

  handleMouseEnter = () => {
    const { time, onTimeHover } = this.props;

    onTimeHover(time);
  };

  render() {
    const { isSelected, isDisabled, time } = this.props;

    return (
      <li
        onClick={!isDisabled && this.handleClick}
        onMouseEnter={!isDisabled && this.handleMouseEnter}
        className={cx('TimeChunk', {
          'TimeChunk--isDefault': !isSelected && !isDisabled,
          'TimeChunk--isSelected': isSelected,
          'TimeChunk--isDisabled': isDisabled,
        })}
      >
        {time}
      </li>
    );
  }
}

export default TimeChunk;
